// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canSetAssetAnnotations } from "./check";

export function useCanSetAssetAnnotations(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction = !!withinScope && canSetAssetAnnotations(withinScope);
  return canDoAction;
}
